/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PhoneValidationStatus = {
    NotApplicable: 'NOT_APPLICABLE',
    PhoneNumberMissing: 'PHONE_NUMBER_MISSING',
    PhoneNumberNeedValidation: 'PHONE_NUMBER_NEED_VALIDATION',
    PhoneNumberValidated: 'PHONE_NUMBER_VALIDATED'
} as const;
export type PhoneValidationStatus = typeof PhoneValidationStatus[keyof typeof PhoneValidationStatus];


export function instanceOfPhoneValidationStatus(value: any): boolean {
    for (const key in PhoneValidationStatus) {
        if (Object.prototype.hasOwnProperty.call(PhoneValidationStatus, key)) {
            // @ts-ignore
            if (PhoneValidationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PhoneValidationStatusFromJSON(json: any): PhoneValidationStatus {
    return PhoneValidationStatusFromJSONTyped(json, false);
}

export function PhoneValidationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneValidationStatus {
    return json as PhoneValidationStatus;
}

export function PhoneValidationStatusToJSON(value?: PhoneValidationStatus | null): any {
    return value as any;
}

